module.exports = require("././angular-cookies.js");


//////////////////
// WEBPACK FOOTER
// angular-cookies (bower component)
// module id = 33
// module chunks = 0 1